import { SsuLogoPlaceholder } from '@capsicum/common';
import { type ObjectDataShape, type PartnerWithImageMap } from '@capsicum/socios-core';

import { type PostMainPartner } from '../models';

/**
 * Shape of the ActivityPartners object.
 */
type ActivityPartnersShape = {
	mainPartnerID: string;
	/**
	 * The data of the activity containing information about two activity teams.
	 */
	postData: ObjectDataShape;
};

/**
 * Helper function to determine the main and second partner teams based on the mainPartnerID.
 */
export const activityPartners = ({ mainPartnerID, postData }: ActivityPartnersShape) => {
	const homeTeam = postData?.sportEvent?.homeTeam || postData?.homeTeam;
	const awayTeam = postData?.sportEvent?.awayTeam || postData?.awayTeam;

	const mainPartnerTeam = mainPartnerID === homeTeam?.partnerId ? homeTeam : awayTeam;
	const secondPartnerTeam = mainPartnerID === homeTeam?.partnerId ? awayTeam : homeTeam;

	return { mainPartnerTeam, secondPartnerTeam };
};

export const partnerWithImageMapToPostMainPartner = (partnerWithImageMap: PartnerWithImageMap): PostMainPartner => {
	return {
		id: partnerWithImageMap.id || '',
		image: partnerWithImageMap.images?.partnerLogo?.url || (SsuLogoPlaceholder as unknown as string),
		name: partnerWithImageMap.name,
		shortName: partnerWithImageMap.shortName
	};
};
